import { render, staticRenderFns } from "./Etapas.vue?vue&type=template&id=f01eaa14&scoped=true&"
import script from "./etapas.ts?vue&type=script&lang=ts&"
export * from "./etapas.ts?vue&type=script&lang=ts&"
import style0 from "./Etapas.vue?vue&type=style&index=0&id=f01eaa14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01eaa14",
  null
  
)

export default component.exports